import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import { fetchRouterDatasetFromPage } from '../fetchRouterDatasetFromPage'

export const getInitialPageDataAndConnections = async (
  pageRef: PageRef,
  newCollectionId: string,
  editorSdkProxy: EditorSDK,
  collectionsApi: CollectionsApi,
) => {
  const [schema, routerRef, controller] = await Promise.all([
    collectionsApi.get(newCollectionId),
    editorSdkProxy.document.routers.getByPage({ pageRef }),
    fetchRouterDatasetFromPage(editorSdkProxy, pageRef),
  ])

  const router = await editorSdkProxy.document.routers.get<RouterConfig>({
    routerRef,
  })

  return {
    schema,
    routerRef,
    controller: controller!,
    router,
  }
}
